import { render, staticRenderFns } from "./FreeTicket.vue?vue&type=template&id=21a256ba&scoped=true&"
import script from "./FreeTicket.vue?vue&type=script&lang=js&"
export * from "./FreeTicket.vue?vue&type=script&lang=js&"
import style0 from "./FreeTicket.vue?vue&type=style&index=0&id=21a256ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a256ba",
  null
  
)

export default component.exports